<div *ngIf="(ie.CustomizeOptions != null && ie.CustomizeOptions.DisplayType == 'captcha') else defaultOfTrigger">
  <div class="mt-2 mb-2" *ngIf="(ie.CustomizeOptions.DisplayType == 'captcha')">
    <re-captcha #captchaRef="reCaptcha"
      [siteKey]="captchaKey" 
      [size]="ie.CustomizeOptions.Properties.CaptchaSize"
      [badge]="ie.CustomizeOptions.Properties.CaptchaBadge"
      [type]="ie.CustomizeOptions.Properties.CaptchaType"
      [theme]="ie.CustomizeOptions.Properties.CaptchaTheme"
      [lang]="ie.CustomizeOptions.Properties.CaptchaLang" 
      (resolved)="$event && captchaSubmit($event, ie)">
    </re-captcha>
    <p class="captcha-success-msg">
      <small>{{captchaNotificationMsg}}</small>
    </p>
    <button class="btn btn-secondary btn-sm mb-2" data-toggle="tooltip" type="button"
      (click)="captchaExecuteMethod()" [disabled]="disableTrigger"
      [id]="ie.InterfaceElementID" [title]="ie.Label.DisplayName">
      {{ie.Label.DisplayName}}
    </button>
  </div>
</div>
<ng-template #defaultOfTrigger>
  <div>
    <button [class]="triggerClass" data-toggle="tooltip" type="button"
    (click)="fetchIEUserAction(ie.Attributes.OnClickUAID)"
    [disabled]="disableTrigger" [id]="ie.InterfaceElementID"
    [title]="ie.Label.DisplayName">
    <i *ngIf="(ie.CustomizeOptions != null && ie.CustomizeOptions.ImageIcon != null)" [id]="'button_' + ie.CustomizeOptions.ImageIcon"></i>
    <span *ngIf="(ie.CustomizeOptions == null || ie.CustomizeOptions.ImageIcon == null)">{{ie.Label.DisplayName}}</span>
  </button>
  </div>

</ng-template>
